import { createAsyncThunk } from "@reduxjs/toolkit";
import { GET_REVIEW_REPORT_DATA } from "../../utils/queries";
import { createGraphQLThunk } from ".";


export const ReviewThunk = createAsyncThunk(
   "reviewSlice/reviewThunk",
  createGraphQLThunk({
    query: GET_REVIEW_REPORT_DATA,
    getVariables: ({ paginationFilter}) => ({  paginationFilter}),
    responseKey: "getReviewReportData",
    notError: true
  })
);
